/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskLanguageRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskLanguageRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskLanguageSupport from './ui/service-desk-language-support/index.tsx';
import { LazyProjectSettingsServiceDeskLanguageTranslations } from './ui/service-desk-language-translations/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskLanguageRouteEntry: Route = createEntry(
	projectSettingsServicedeskLanguageRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'service-management.languages',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskLanguageSupport,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskLanguageTranslations],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
